import React from 'react'

import type { TableTypeMap } from '@material-ui/core/Table'
import MuiTable from '@material-ui/core/Table'
import type { OverridableComponent } from '@material-ui/core/OverridableComponent'

const Table: OverridableComponent<TableTypeMap> = (props: any) => <MuiTable component="div" {...props} />

export default Table
